// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const ro: ChromeTranslations = {
  'nav.nextPage': 'pagina următoare →',
  'nav.previousPage': '← pagina anterioară',
  'nav.continueToLevel': 'continuă la nivel →',
  'nav.backToMenu': 'înapoi la meniu →',
  'howto.page': 'pagina {n} din {total}',
  'options.title': 'Opțiuni',
  'ui.language': 'Limbă',
};
